import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { collection, getDocs, orderBy, query, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import Menu from '../../panel/Menu';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function Expensereport() {

  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });

  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [expenseHeads, setExpenseHeads] = useState([]);
  const [expenseReport, setExpenseReport] = useState({});

  useEffect(() => {
    fetchExpenseHeads();
  }, []);

  // ✅ Fetch Expense Heads
  const fetchExpenseHeads = async () => {
    try {
      const q = query(collection(db, "expensehead"), orderBy("createdAt", "asc"));
      const snap = await getDocs(q);

      const heads = snap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      console.log(heads);
      setExpenseHeads(heads);

    } catch (error) {
      Toast.fire({ icon: "error", title: error.message });
    }
  };

  const getReport = async () => {

    if (!fromDate || !toDate) {
      Toast.fire({ icon: "error", title: "Please select both dates" });
      return;
    }

    setLoading(true);

    try {

      const startDate = moment(fromDate);
      const endDate = moment(toDate);

      const startStr = startDate.format("YYYY-MM-DD");
      const endStr = endDate.format("YYYY-MM-DD");

      const q = query(
        collection(db, "expenses"),
        where("date", ">=", startStr),
        where("date", "<=", endStr)
      );

      const snap = await getDocs(q);

      let report = {};

      // ✅ First create all dates between range
      let current = startDate.clone();
      while (current.isSameOrBefore(endDate)) {
        report[current.format("YYYY-MM-DD")] = {};
        current.add(1, "day");
      }

      // ✅ Now fill expenses
      snap.forEach(docSnap => {

        const data = docSnap.data();
        const date = data.date;
        const headId = data.headid;
        const amount = parseFloat(data.amount || 0);

        if (!report[date]) {
          report[date] = {};
        }

        if (!report[date][headId]) {
          report[date][headId] = 0;
        }

        report[date][headId] += amount;
      });

      setExpenseReport(report);

    } catch (error) {
      Toast.fire({ icon: "error", title: error.message });
    }

    setLoading(false);
  };

  const downloadExcel = () => {

    if (Object.keys(expenseReport).length === 0) {
      Toast.fire({ icon: "error", title: "No data to export" });
      return;
    }

    let data = [];

    const dates = Object.keys(expenseReport).sort();

    dates.forEach(date => {

      let row = {};
      let rowTotal = 0;

      row["Date"] = moment(date).format("DD/MM/YYYY");

      expenseHeads.forEach(head => {

        const amount = expenseReport[date][head.id] || 0;

        row[head.staffcat || head.headname] = amount;
        rowTotal += amount;
      });

      row["Total"] = rowTotal;

      data.push(row);
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Terij Patrak");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    saveAs(fileData, "TerijPatrak.xlsx");
  };



  return (
    <div>
      <Menu />
      <div className="content-wrapper">
        <section className="content mt-2">
          <div className="container-fluid">

            <button className="btn btn-secondary">
              || Terij Patrak ||
            </button>

            <br /><br />

            {/* Date Filter */}
            <div className="card card-primary card-outline">
              <div className="card-body">
                <div className='row'>
                  <div className='col-sm-3'>
                    <label>From Date</label>
                    <input
                      type='date'
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      className='form-control'
                    />
                  </div>

                  <div className='col-sm-3'>
                    <label>To Date</label>
                    <input
                      type='date'
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      className='form-control'
                    />
                  </div>

                  <div className='col-sm-3'>
                    <br />
                    <button
                      className='btn btn-info'
                      onClick={getReport}
                    >
                      Get Report
                    </button>
                  </div>
                  <div className='col-sm-3'>
                    <br />
                    <button
                      className='btn btn-success'
                      onClick={downloadExcel}
                    >
                      Download Excel
                    </button>
                  </div>

                </div>
              </div>
            </div>

            {/* Report Table */}
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Date</th>

                    {expenseHeads.map(head => (
                      <th key={head.id}>
                        {head.staffcat || head.headname}
                      </th>
                    ))}

                    <th>Total</th>
                  </tr>
                </thead>

                <tbody>
                  {
                    Object.keys(expenseReport).length > 0 ? (

                      (() => {

                        let grandTotal = 0;

                        return (
                          <>
                            {Object.keys(expenseReport)
                              .sort()
                              .map((date, index) => {

                                let rowTotal = 0;

                                return (
                                  <tr key={index}>
                                    <td>
                                      {moment(date).format("DD/MM/YYYY")}
                                    </td>

                                    {expenseHeads.map(head => {

                                      const amount =
                                        expenseReport[date][head.id] || 0;

                                      rowTotal += amount;

                                      return (
                                        <td key={head.id}>
                                          {amount}
                                        </td>
                                      );
                                    })}

                                    <td style={{ fontWeight: "bold" }}>
                                      {rowTotal}
                                    </td>
                                  </tr>
                                );
                              })}

                            {/* Grand Total Row */}
                            <tr style={{ background: "#f5f5f5", fontWeight: "bold" }}>
                              <td>Total</td>

                              {expenseHeads.map(head => {

                                let headTotal = 0;

                                Object.keys(expenseReport).forEach(date => {
                                  headTotal += expenseReport[date][head.id] || 0;
                                });

                                grandTotal += headTotal;

                                return (
                                  <td key={head.id}>
                                    {headTotal}
                                  </td>
                                );
                              })}

                              <td>{grandTotal}</td>
                            </tr>
                          </>
                        );
                      })()

                    ) : (
                      <tr>
                        <td colSpan={expenseHeads.length + 2}
                          className="text-center">
                          No expense data found.
                        </td>
                      </tr>
                    )
                  }
                </tbody>
              </table>
            </div>

          </div>
        </section>
      </div>
    </div>
  )
}

export default Expensereport;
